module.exports = __webpack_public_path__ + "img/claro.a5c169a8.png";